<form [formGroup]="insolePrescription">
    <div class="header-container">
        <div style="display: flex; flex-direction: column; gap: 8px;">
            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;"
                (click)="selectShellType('thin')"
                [class.selected]="insolePrescription.get('shellType')?.value === 'thin'">
                <img class="horitzontal-image" src="assets/images/insole-types/thin-insole-new.png" alt="">
                <span class="image-label">{{ 'THIN' | translate }}</span>
            </div>
            <div style="display: flex; align-items: center; gap: 8px; cursor: pointer;"
                (click)="selectShellType('thick')"
                [class.selected]="insolePrescription.get('shellType')?.value === 'thick'">
                <img class="horitzontal-image" src="assets/images/insole-types/thick-insole-new.png" alt="">
                <span class="image-label">{{ 'THICK' | translate }}</span>
            </div>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer;"
                (click)="selectLengthType('3-4')"
                [class.selected]="insolePrescription.get('lengthType')?.value === '3-4'">
                <span class="image-label">3/4</span>
                <img class="vertical-image" src="assets/images/insole-types/3-4-new.png" alt="">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer;"
                (click)="selectLengthType('sulcus')"
                [class.selected]="insolePrescription.get('lengthType')?.value === 'sulcus'">
                <span class="image-label">{{ 'SULCUS' | translate }}</span>
                <img class="vertical-image" src="assets/images/insole-types/suculus-new.png" alt="">
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px; cursor: pointer;"
                (click)="selectLengthType('full')"
                [class.selected]="insolePrescription.get('lengthType')?.value === 'full'">
                <span class="image-label">{{ 'FULL_LENGTH' | translate }}</span>
                <img class="vertical-image" src="assets/images/insole-types/full-length-new.png" alt="">
            </div>
        </div>
    </div>
    <div *ngIf="insolePrescription.get('shellType')?.value === 'thin'" class="thickness-selector">
        <label class="thickness-label">{{ 'THICKNESS' | translate }} (mm)</label>
        <div class="thickness-options">
            <div *ngFor="let thickness of thicknessOptions" class="thickness-ball"
                [class.selected]="insolePrescription.get('thinThickness')?.value === thickness"
                (click)="selectThickness(thickness)">
                {{ thickness }}
            </div>
        </div>
    </div>
    <mat-tab-group>
        <mat-tab label="{{ 'SHELL_MODIFICATIONS' | translate }}">
            <div class="components-container">
                <div class="toggle-button-container">
                    <button *ngIf="prescriptionTemplates?.length > 0" mat-raised-button color="primary"
                        class="btn btn-block" (click)="showTemplatesModal()">
                        {{ 'TEMPLATES' | translate }}
                    </button>
                    <button mat-raised-button color="primary" class="btn btn-block icon-button"
                        matTooltip="{{ '3D_PREVIEWER' | translate }}" matTooltipPosition="above"
                        (click)="show3DPreviewModal()">
                        <tabler-icon name="brand-unity" size="24"></tabler-icon>
                    </button>
                    <button mat-raised-button color="primary" class="btn btn-block icon-button"
                        matTooltip="{{ 'EXPAND_CLOSE_ALL' | translate }}" matTooltipPosition="above"
                        (click)="toggleExpandCollapse()">
                        <tabler-icon [name]="expandAll ? 'arrows-minimize' : 'arrows-maximize'" size="24"></tabler-icon>
                    </button>
                </div>

                <app-insole-component *ngFor="let component of insoleComponents | filterByGroup: 'shellModifications'"
                    [title]="component.title" 
                    [translationKey]="component.translationKey"
                    [imageUrl]="component.imageUrl"
                    [footSelectionOptions]="component.footSelectionOptions" [selectOptions]="component.selectOptions"
                    [typeSelectOptions]="component.typeSelectOptions" [medialLateralType]="component.medialLateralType"
                    [reversedBooleanOption]="component.reversedBooleanOption"
                    [componentForm]="getFormGroupFromComponent(component.form)" [expandAll]="expandAll"
                    [disabledReason]="disabledReasons[getFormGroupFromComponent(component.form).get('type')?.value]"
                    [warningMessage]="warningMessages[getFormGroupFromComponent(component.form).get('type')?.value]"
                    (updateEvent)="onChildFormUpdate($event, component)">
                </app-insole-component>
            </div>
        </mat-tab>
        <mat-tab label="{{ 'POSTINGS' | translate }}">
            <div class="components-container">
                <div class="toggle-button-container">
                    <button mat-raised-button color="primary" class="btn btn-block icon-button"
                        matTooltip="{{ '3D_PREVIEWER' | translate }}" matTooltipPosition="above"
                        (click)="show3DPreviewModal()">
                        <tabler-icon name="brand-unity" size="24"></tabler-icon>
                    </button>
                    <button mat-raised-button color="primary" class="btn btn-block icon-button"
                        matTooltip="{{ 'EXPAND_CLOSE_ALL' | translate }}" matTooltipPosition="above"
                        (click)="toggleExpandCollapse()">
                        <tabler-icon [name]="expandAll ? 'arrows-minimize' : 'arrows-maximize'" size="24"></tabler-icon>
                    </button>
                </div>

                <app-insole-component *ngFor="let component of insoleComponents | filterByGroup: 'postings'"
                    [title]="component.title" 
                    [translationKey]="component.translationKey"
                    [imageUrl]="component.imageUrl"
                    [footSelectionOptions]="component.footSelectionOptions" [selectOptions]="component.selectOptions"
                    [typeSelectOptions]="component.typeSelectOptions" [medialLateralType]="component.medialLateralType"
                    [reversedBooleanOption]="component.reversedBooleanOption"
                    [componentForm]="getFormGroupFromComponent(component.form)" [expandAll]="expandAll"
                    [disabledReason]="disabledReasons[getFormGroupFromComponent(component.form).get('type')?.value]"
                    [warningMessage]="warningMessages[getFormGroupFromComponent(component.form).get('type')?.value]"
                    (updateEvent)="onChildFormUpdate($event, component)">
                </app-insole-component>
            </div>
        </mat-tab>

    </mat-tab-group>
</form>

<!-- Prescription templates modal -->
<p-dialog header="{{ 'SELECT_A_TEMPLATE' | translate }}" [(visible)]="templatesModalVisible" [modal]="true"
    [style]="{'height': '90vh'}" [contentStyle]="{'overflow-y': 'auto'}" (onHide)="onTemplatesModalClose()">
    <div class="product-selection" *ngIf="prescriptionTemplates">
        <mat-card *ngFor="let prescriptionTemplate of prescriptionTemplates" class="cardWithShadow product-card"
            (click)="selectTemplate(prescriptionTemplate.ID)">

            <div class="p-card-content">
                <span class="template-badge">{{ prescriptionTemplate?.name }}</span>
                <p style="font-size: small;">{{ prescriptionTemplate?.description }}</p>

                <div class="component-list-container">
                    <div *ngFor="let component of prescriptionTemplate?.prescription?.components"
                        style="display: flex; align-items: center; gap: 5px;">
                        <tabler-icon name="circle-check" size="24"></tabler-icon>
                        <span class="component-name">{{ component.type | formatComponentType }}</span>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</p-dialog>

<p-dialog header="{{ '3D_PREVIEWER' | translate }}" [(visible)]="threeDPreviewModalVisible" [modal]="true"
    (onHide)="on3DPreviewModalClose()" (onShow)="on3DModalShown()"
    [style]="{ width: '100vw', height: '90vh', margin: '0', padding: '0' }" [maximizable]="false">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <div *ngIf="token && token !== null && token !== ''" style="width: 100%; height: 100%; margin: 0; padding: 0;">
        <iframe id="3D_previewer" class="previewer-iframe"
            sandbox="allow-scripts allow-same-origin allow-storage-access-by-user-activation"
            [src]="iframeUrl"></iframe>
    </div>
</p-dialog>